import _round from "lodash/round";

export const formatRoundValue = (value, decimal) => {
    return _round(value, decimal);
}
